/* TODO: t() */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { StyleSheet, ScrollView } from 'react-native';
import { sortableContainer } from 'react-sortable-hoc/dist/react-sortable-hoc';
import { Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';

import { FormSubmission } from '../../types/shared/FormSubmission';
import { EvaluationFormDefinition } from '../../types/shared/EvaluationForm';
import { useFetchJson } from '../../support/useFetch';
import { Text } from '../uiold';
import LoadingIndicator from '../uiold/LoadingIndicator';

import FormElement from './FormElement';
import { FormElementMode } from './types';

type Props = {
  formDef: EvaluationFormDefinition;
  // TODO: Fix typings
  // When mode="builder", FormElementList also accept SortableContainer props
  // ref: https://github.com/clauderic/react-sortable-hoc#sortablecontainer-hoc
  mode: FormElementMode;
  innerRef?: any;
  cacheRef?: any;
};

let WIDTH = 768;

function FormElementListPlaceholder({ mode }: Props) {
  return mode === 'builder' ? (
    <Text type="label">{`You don't have any questions. `}</Text>
  ) : (
    <Text type="label">
      {`You don't have any questions. `}
      <Link to="/market-metrics/builder">Click Here</Link> to edit your form.
    </Text>
  );
}

function FormElementListInner(props: Props) {
  let { formDef, mode } = props;
  let isListEmpty = formDef.fields.length === 0;
  return (
    <ScrollView style={styles.root}>
      {isListEmpty && <FormElementListPlaceholder {...props} />}
      {formDef.fields.map((field, index) => {
        let first = index === 0;
        let last = index === formDef.fields.length - 1;
        return (
          <FormElement
            key={field.id}
            first={first}
            last={last}
            sortIndex={index}
            mode={mode}
            definition={field}
            {
              // TODO: Can we remove this index prop?
              ...{ index }
            }
          />
        );
      })}
    </ScrollView>
  );
}

let FormElementListSortable = sortableContainer(FormElementListInner);

let styles = StyleSheet.create({
  root: {
    flex: 1,
    maxWidth: WIDTH,
    overflow: 'hidden',
  },
});

export function FormElementList(props: Props) {
  let Component =
    props.mode === 'builder' ? FormElementListSortable : FormElementListInner;
  return <Component {...props} />;
}

type FormElementListWithFetchProps = Expand<
  Omit<Props, 'formDef'> & { selectedSubmission: FormSubmission }
>;

export function FormElementListWithFetch(props: FormElementListWithFetchProps) {
  const { selectedSubmission, ...otherProps } = props;
  const fetchJson = useFetchJson();
  const { data: formDef, error } = useQuery(
    ['forms/evaluation', selectedSubmission.revision],
    () => {
      const url = `/api/forms/evaluation/${selectedSubmission.revision}`;
      return fetchJson<EvaluationFormDefinition>(url);
    },
  );

  if (error) {
    <p>{String(error)}</p>;
  }

  if (!formDef) {
    return <LoadingIndicator />;
  }

  return <FormElementList formDef={formDef} {...otherProps} />;
}
